import React, { useEffect } from "react";
import DatePicker from "~/components/DatePicker";
import { Row, Col, Form, Modal, ListGroup, Alert } from "react-bootstrap";
import { FaTrash } from "react-icons/fa";
import EventItem from "./EventItem";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import { Button, Stack, Tabs, Tab } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Select from "@mui/material/Select";
import moment from "moment";
import { withNamespaces } from "react-i18next";

const Modals = ({
  showModalWithDaysMarkedConfirm,
  showModalCheckDays,
  handleModalCloseCheckDays,
  showModalCriteria,
  handleModalCloseCriteria,
  showModalWithDaysToRemove,
  handleModalCloseDaysToRemove,
  showModalWithDaysMarked,
  handleModalClose,
  handleCheckboxChange,
  handleSaveWorkDays,
  isDisabled,
  eventsTemp,
  selectedLocale,
  marcacaoFeriasCalendario,
  marcacaoFeriasmsg,
  events,
  removeDayFromEvents,
  updateEventState,
  removeDayFromEventsTemp,
  handleSaveWorkDaysConfirm,
  confirmRemoveDaysSelected,
  setConfirmRemoveDaysSelected,
  handleRemoveDays,
  handleConfirmRemoveDays,
  gruposTrabalhoRemoto,
  criteriaGroup,
  setCriteriaGroup,
  startAt,
  setStartAt,
  endAt,
  setEndAt,
  handleSendCriteriaData,
  setShowModalWithDaysMarked,
  setShowModalWithDaysMarkedConfirm,
  t,
}) => {
  function ModalWithCheckDays(props) {
    return (
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            <h4>{t("portalrh.workDays.listmarkedDays")}</h4>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body></Modal.Body>
        <Modal.Footer>
          <Stack direction="row" spacing={2}>
            <Button
            id="button_vacations_modals_checkDays_close"
              variant="contained"
              className="card-button-red"
              onClick={handleModalCloseCheckDays}
            >
              {t("portalrh.workDays.close")}
            </Button>
            <Button
            id="button_vacations_modals_checkDays_save"
              variant="contained"
              color="success"
              className="card-button-scheduler"
              onClick={handleSaveWorkDays}
            >
              {t("portalrh.workDays.submitDay")}
            </Button>
          </Stack>
        </Modal.Footer>
      </Modal>
    );
  }

  function ModalWithCriteria(props) {
    return (
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            <h4>{t("portalrh.workDays.export.title")}</h4>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row style={{ margin: "10px 0px" }}>
            <Col lg="12" style={{ padding: "0px" }}>
              <InputLabel>{t("portalrh.workDays.export.groups")}</InputLabel>
              <Select
                value={criteriaGroup}
                onChange={(e) => setCriteriaGroup(e.target.value)}
                displayEmpty
                inputProps={{ "aria-label": "Select group" }}
              >
                <MenuItem value="">{t("portalrh.workDays.all")}</MenuItem>
                {Object.keys(gruposTrabalhoRemoto).length > 0 &&
                  gruposTrabalhoRemoto.map((group) => (
                    <MenuItem key={group.grupo.id} value={group.grupo.id}>
                      {group.grupo.designacao}
                    </MenuItem>
                  ))}
              </Select>
            </Col>
          </Row>
          <Row>
            <Col lg="6">
              <InputLabel>{t("portalrh.workDays.export.startDate")}</InputLabel>
              <DatePicker
                value={startAt}
                onChange={(e) => setStartAt(e)}
                format="dd/MM/yyyy"
              />
            </Col>
            <Col lg="6">
              <InputLabel>{t("portalrh.workDays.export.endDate")}</InputLabel>
              <DatePicker
                value={endAt}
                onChange={(e) => setEndAt(e)}
                format="dd/MM/yyyy"
              />
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Stack direction="row" spacing={2}>
            <Button
            id="button_vacations_modals_criteria_close"
              variant="contained"
              className="card-button-red"
              onClick={handleModalCloseCriteria}
            >
              {t("portalrh.workDays.close")}
            </Button>
            <Button
            id="button_vacations_modals_criteria_send"
              variant="contained"
              color="success"
              className="card-button-scheduler"
              onClick={handleSendCriteriaData}
            >
              {t("portalrh.workDays.export.btn")}
            </Button>
          </Stack>
        </Modal.Footer>
      </Modal>
    );
  }

  function ModalWithDaysToRemove(props) {
    return (
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            <h4>
              {eventsTemp.some((event) => event.type === "feriasPendentes")
                ? t("portalrh.workDays.reuqestCanceled")
                : t("portalrh.workDays.requestFeriasCanceled")}
            </h4>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {!eventsTemp.some((event) => event.type === "feriasPendentes") && (
            <Form.Label>{t("portalrh.workDays.selectDaysToRemove")}</Form.Label>
          )}
          <ListGroup
            style={{ overflowY: "auto", maxHeight: "350px", padding: "10px" }}
            className="scrollBar-visible-year"
          >
            {eventsTemp.map((event) => (
              <EventItem
                key={event.id}
                event={event}
                updateEventState={updateEventState}
                removeDayFromEvents={removeDayFromEventsTemp}
                disabled={true}
                isToRemove={true}
                selectedLocale={selectedLocale}
              />
            ))}
          </ListGroup>
        </Modal.Body>
        <Modal.Footer>
          <Stack direction="row" spacing={2}>
            {confirmRemoveDaysSelected ? (
              <>
                <Button
                id="button_vacations_modals_daysRemove_back"
                  variant="contained"
                  className="card-button-red"
                  onClick={() => setConfirmRemoveDaysSelected(false)}
                >
                  {t("portalrh.workDays.back")}
                </Button>
                <Button
                id="button_vacations_modals_daysRemove_confirm"
                  variant="contained"
                  color="success"
                  className="card-button-scheduler"
                  onClick={() =>
                    handleConfirmRemoveDays(
                      eventsTemp,
                      handleModalCloseDaysToRemove
                    )
                  }
                >
                  {eventsTemp.some((event) => event.type === "feriasPendentes")
                    ? t("portalrh.workDays.confirmCancelRequest")
                    : t("portalrh.workDays.confirmarCancelamento")}
                </Button>
              </>
            ) : (
              <>
                <Button
                id="button_vacations_modals_daysRemove_close"
                  variant="contained"
                  className="card-button-red"
                  onClick={handleModalCloseDaysToRemove}
                >
                  {t("portalrh.workDays.close")}
                </Button>
                <Button
                id="button_vacations_modals_daysRemove_remove"
                  variant="contained"
                  color="success"
                  className="card-button-scheduler"
                  onClick={handleRemoveDays}
                  disabled={eventsTemp.every(
                    (eventDay) =>
                      !eventDay.daytoRemove &&
                      eventDay.type === "datasMarcacoes"
                  )}
                >
                  {eventsTemp.some((event) => event.type === "feriasPendentes")
                    ? t("portalrh.workDays.calcenRequest")
                    : t("portalrh.workDays.selectedFeriasMarcadas")}
                </Button>
              </>
            )}
          </Stack>
        </Modal.Footer>
      </Modal>
    );
  }

  function ModalWithDaysMarked(props) {
    return (
      <Modal
        {...props}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            <h4>{t("portalrh.workDays.listmarkedDays")}</h4>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {((marcacaoFeriasCalendario.sPendente === 0 &&
            (eventsTemp.some((event) => event.empConsumoSaldo === "0") ||
              eventsTemp.some((event) => event.empConsumoSaldo === "2"))) ||
            (marcacaoFeriasCalendario.sPendente === 0.5 &&
              eventsTemp.some((event) => !event.checkedHalfDay) &&
              (eventsTemp.some((event) => event.empConsumoSaldo === "0") ||
                eventsTemp.some(
                  (event) => event.empConsumoSaldo === "2"
                )))) && (
            <Alert variant="info">{t("portalrh.workDays.dontHaveSaldo")}</Alert>
          )}
          {marcacaoFeriasCalendario.sPendenteAnoAnt === 0 &&
            eventsTemp.some((event) => event.empConsumoSaldo === "1") && (
              <Alert variant="info">
                {t("portalrh.workDays.dontHaveSaldoLastYear")}
              </Alert>
            )}
          <ListGroup
            style={{
              overflowY: "auto",
              maxHeight: "300px",
              padding: "10px",
              height: "300px",
            }}
            className="scrollBar-visible-year"
          >
            {eventsTemp
              .filter((event) => !event.removeDay)
              .map((event) => (
                <EventItem
                  key={event.id}
                  event={event}
                  updateEventState={updateEventState}
                  removeDayFromEvents={removeDayFromEventsTemp}
                  disabled={false}
                  isToRemove={false}
                  selectedLocale={selectedLocale}
                />
              ))}
          </ListGroup>
        </Modal.Body>
        <Modal.Footer>
          <Stack direction="row" spacing={2}>
            <Button
            id="button_vacations_modals_daysMarked_close"
              variant="contained"
              className="card-button-red"
              onClick={handleModalClose}
            >
              {t("portalrh.workDays.close")}
            </Button>
            <Button
            id="button_vacations_modals_daysMarked_save"
              variant="contained"
              color="success"
              className="card-button-scheduler"
              onClick={handleSaveWorkDays}
              disabled={isDisabled}
            >
              {t("portalrh.workDays.submitDay")}
            </Button>
          </Stack>
        </Modal.Footer>
      </Modal>
    );
  }

function ModalWithDaysMarkedConfirm(props) {
    const eventsDays =
      events &&
      events.filter(
        (event) => event.type === "feriasmarked" || event.type === "intervals"
      );

    useEffect(() => {
      if (eventsDays !== undefined && eventsDays.length < 1) {
        setShowModalWithDaysMarked(false);
        setShowModalWithDaysMarkedConfirm(false);
      }
    }, [eventsDays]);

    if (eventsDays == undefined) {
      return null;
    }

    return (
      <>
        {eventsDays && (
          <Modal
            {...props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title id="contained-modal-title-vcenter">
                <h4>{t("portalrh.workDays.daysToConfirm")}</h4>
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {marcacaoFeriasmsg?.semanal?.length > 0 && (
                <>
                  <p>
                    {t("portalrh.workDays.textoDiasSemanais.1")}{" "}
                    {marcacaoFeriasmsg.semanal.length}{" "}
                    {t("portalrh.workDays.textoDiasSemanais.2")}
                  </p>
                  <ListGroup
                    style={{
                      overflowY: "auto",
                      maxHeight: "225px",
                      padding: "10px",
                    }}
                    className="scrollBar-visible-year"
                  >
                    {renderListModals(marcacaoFeriasmsg.semanal)}
                  </ListGroup>
                </>
              )}
              {marcacaoFeriasmsg?.exedente?.length > 0 && (
                <>
                  <p>
                    {t("portalrh.workDays.textoDiasExcedentes.1")}{" "}
                    {marcacaoFeriasmsg.exedente.length}{" "}
                    {t("portalrh.workDays.textoDiasExcedentes.2")}
                  </p>
                  <ListGroup
                    style={{
                      overflowY: "auto",
                      maxHeight: "225px",
                      padding: "10px",
                    }}
                    className="scrollBar-visible-year"
                  >
                    {renderListModals(marcacaoFeriasmsg.exedente)}
                  </ListGroup>
                </>
              )}
              {marcacaoFeriasmsg?.bolsa?.length > 0 && (
                <>
                  <p>
                    {t("portalrh.workDays.textoBolsa.1")}{" "}
                    {marcacaoFeriasmsg.bolsa.length}{" "}
                    {t("portalrh.workDays.textoBolsa.2")}
                  </p>
                  <ListGroup
                    style={{
                      overflowY: "auto",
                      maxHeight: "330px",
                      padding: "10px",
                    }}
                    className="scrollBar-visible-year"
                  >
                    {renderListModals(marcacaoFeriasmsg.bolsa)}
                  </ListGroup>
                </>
              )}
            </Modal.Body>
            <Modal.Footer>
              <Stack direction="row" spacing={2}>
                <Button
                id="button_vacations_modals_daysMarkedConfirm_close"
                  variant="contained"
                  className="card-button-red"
                  onClick={props.onHide}
                >
                  {t("portalrh.workDays.close")}
                </Button>
                <Button
                id="button_vacations_modals_daysMarkedConfirm_confirm"
                  variant="contained"
                  color="success"
                  className="card-button-scheduler"
                  onClick={handleSaveWorkDaysConfirm}
                >
                  {t("portalrh.workDays.confirmDays")}
                </Button>
              </Stack>
            </Modal.Footer>
          </Modal>
        )}
      </>
    );
  }

  const renderListModals = (entry, add) =>
    entry.map((day) => (
      <ListGroup.Item
        key={day.date}
        style={{ display: "flex", flexDirection: "column" }}
      >
        {day?.intervals?.length > 0 ? null : (
          <div style={{ display: "flex", marginBottom: "5px" }}>
            <FormControlLabel
              style={{ margin: "0px" }}
              label={t("portalrh.workDays.diaInteiro")}
              control={
                <Checkbox
                  style={{ margin: "0px" }}
                  checked={add ? day.checked : day.diaInteiro === "0"}
                  disabled={!add}
                  onChange={() => handleCheckboxChange(day, "diaInteiro")}
                />
              }
            />
            <FormControlLabel
              style={{ margin: "0px", marginLeft: "10px" }}
              label={t("portalrh.workDays.diasMarcadosMeiodia")}
              control={
                <Checkbox
                  style={{ margin: "0px" }}
                  checked={add ? day.checkedHalfDay : day.diaInteiro === "1"}
                  disabled={!add}
                  onChange={() => handleCheckboxChange(day, "halfDay")}
                />
              }
            />
          </div>
        )}
        <div
          style={{ width: "100%", display: "flex", flexDirection: "column" }}
        >
          <b
            style={{ cursor: "default", display: "flex", alignItems: "center" }}
          >
            {add
              ? moment(day.start).format(
                  `DD [${t("portalrh.workDays.de")}] MMMM [${t(
                    "portalrh.workDays.de"
                  )}] YYYY`
                )
              : moment(day.date).format(
                  `DD [${t("portalrh.workDays.de")}] MMMM [${t(
                    "portalrh.workDays.de"
                  )}] YYYY`
                )}
            {add && (
              <div
                style={{
                  cursor: "pointer",
                  marginLeft: "auto",
                  color: "#AD3E3E",
                }}
                onClick={() => removeDayFromEvents(day)}
              >
                <FaTrash />
              </div>
            )}
          </b>
          {day?.intervals?.length > 0 &&
            day.intervals.map((interval) => (
              <b key={interval}>
                {moment(interval).format(
                  `DD [${t("portalrh.workDays.de")}] MMMM [${t(
                    "portalrh.workDays.de"
                  )}] YYYY`
                )}
              </b>
            ))}
        </div>
      </ListGroup.Item>
    ));

  return (
    <>
      <ModalWithDaysMarkedConfirm
        show={showModalWithDaysMarkedConfirm}
        onHide={handleModalClose}
      />
      <ModalWithCheckDays
        show={showModalCheckDays}
        onHide={handleModalCloseCheckDays}
      />
      <ModalWithCriteria
        show={showModalCriteria}
        onHide={handleModalCloseCriteria}
      />
      <ModalWithDaysToRemove
        show={showModalWithDaysToRemove}
        onHide={handleModalCloseDaysToRemove}
      />
      <ModalWithDaysMarked
        show={showModalWithDaysMarked}
        onHide={handleModalClose}
      />
    </>
  );
};

export default withNamespaces()(Modals);
